(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');

    // click-directive to edit a task 
    module.directive('taskEdit', ['TaskService',
        function (TaskService) {
            var directive = {
                link: link,
                restrict: 'A',
                scope: {
                    id: '=' // task id                    
                }
            };
            return directive;

            function link(scope, element) {

                // click listener
                element.on('click', function (e) {
                    edit();
                    e.preventDefault();
                    e.stopPropagation();
                });

                // edit
                function edit() {
                    TaskService.editTask(scope.id);
                } // edit

                // on destroy
                scope.$on("$destroy", function () {
                    element.off("click");
                });

            }
        }]);

})();